import React, { useEffect, useRef, useState } from 'react'
import * as S from './styles'

import { useWindowSize } from '@/contexts/WindowSizeContext'

import Logo from '@/components/Header/Logo'
import EmailButton from '@/components/EmailButton'

import {
  COUNTRIES,
  getCountryId,
  getDefaultLanguage,
  changeClientLanguage,
  getLocalizedZendeskLink,
  getItemByLang
} from '@/services/language'
import { LOCAL_KEYS } from '@/services/browserStorage'
import { EVENT_KEYS } from '@/services/events'
import { ASSET_PATHS, EXTERNAL_PATHS, PAGE_PATHS } from '@/services/paths'
import ImageNext from '@/components/ImageNext'
import { useTranslation } from 'react-i18next'
import ReactFlagsSelect from 'react-flags-select'
import Link from 'next/link'

const FooterUnsigned = () => {
  const { t, i18n } = useTranslation()
  const languageCode = i18n.language.split('-')[0]

  const { windowSize } = useWindowSize()

  const [titlesContents, setTitlesContents] = useState('')
  const [titlesTeaching, setTitlesTeaching] = useState('')
  const [titlesResources, setTitlesResources] = useState('')
  const [titlesIntegration, setTitlesIntegration] = useState('')
  const [titlesContact, setTitlesContact] = useState('')
  const [titlesHelp, setTitlesHelp] = useState('')
  const [titlesCompliance, setTitlesCompliance] = useState('')
  const [titlesOrgans, setTitlesOrgans] = useState('')
  const [titlesCellStructure, setTitlesCellStructure] = useState('')
  const [titlesDevelopment, setTitlesDevelopment] = useState('')
  const [titlesSpecialties, setTitlesSpecialties] = useState('')
  const [titlesAPI, setTitlesAPI] = useState('')
  const [titlesInstitutions, setTitlesInstitutions] = useState('')
  const [titlesWhiteLabel, setTitlesWhiteLabel] = useState('')
  const [titlesCompleteAnatomy, setTitlesCompleteAnatomy] = useState('')
  const [titlesTopographicAnatomy, setTitlesTopographicAnatomy] = useState('')
  const [titlesSystemicAnatomy, setTitlesSystemicAnatomy] = useState('')
  const [titlesCytology, setTitlesCytology] = useState('')
  const [titlesEmbryology, setTitlesEmbryology] = useState('')
  const [titlesPhysiology, setTitlesPhysiology] = useState('')
  const [titlesHistology, setTitlesHistology] = useState('')
  const [titlesHistopathology, setTitlesHistopathology] = useState('')
  const [titlesPathology, setTitlesPathology] = useState('')
  const [titlesRadiology, setTitlesRadiology] = useState('')
  const [titlesForTeachers, setTitlesForTeachers] = useState('')
  const [titlesForStudents, setTitlesForStudents] = useState('')
  const [titlesCollections, setTitlesCollections] = useState('')
  const [titlesApp, setTitlesApp] = useState('')
  const [titlesViewer3D, setTitlesViewer3D] = useState('')
  const [titlesSlideViewer, setTitlesSlideViewer] = useState('')
  const [titlesRadiologyViewer, setTitlesRadiologyViewer] = useState('')
  const [subtitlesGroup, setSubtitlesGroup] = useState('')
  const [labelsUseTerms, setLabelsUseTerms] = useState('')
  const [labelsPolitics, setLabelsPolitics] = useState('')
  const [labelsCookies, setLabelsCookies] = useState('')
  const [labelsRequests, setLabelsRequests] = useState('')
  const [labelsContactWhats, setLabelsContactWhats] = useState('Whatsapp')

  const [whatsAppLink, setWhatsAppLink] = useState('')

  const [selectedFlag, setSelectedFlag] = useState()

  const didInit = useRef(false)

  useEffect(() => {
    setTitlesContents(t('titles.contents'))
    setTitlesTeaching(t('titles.teaching'))
    setTitlesResources(t('titles.resources'))
    setTitlesIntegration(t('titles.integration'))
    setTitlesContact(t('titles.contact'))
    setTitlesHelp(t('titles.help'))
    setTitlesCompliance(t('titles.compliance'))
    setTitlesOrgans(t('titles.organs'))
    setTitlesCellStructure(t('titles.cellStructure'))
    setTitlesDevelopment(t('titles.development'))
    setTitlesSpecialties(t('titles.specialties'))
    setTitlesAPI(t('titles.api'))
    setTitlesInstitutions(t('titles.institutions'))
    setTitlesWhiteLabel(t('titles.whiteLabel'))
    setTitlesCompleteAnatomy(t('titles.completeAnatomy'))
    setTitlesTopographicAnatomy(t('titles.topographicAnatomy'))
    setTitlesSystemicAnatomy(t('titles.systemicAnatomy'))
    setTitlesCytology(t('titles.cytology'))
    setTitlesEmbryology(t('titles.embryology'))
    setTitlesPhysiology(t('titles.physiology'))
    setTitlesHistology(t('titles.histology'))
    setTitlesHistopathology(t('titles.histopathology'))
    setTitlesPathology(t('titles.pathology'))
    setTitlesRadiology(t('titles.radiology'))
    setTitlesForTeachers(t('titles.forTeachers'))
    setTitlesForStudents(t('titles.forStudents'))
    setTitlesCollections(t('titles.collections'))
    setTitlesApp(t('titles.app'))
    setTitlesViewer3D(t('titles.viewer3d'))
    setTitlesSlideViewer(t('titles.slideViewer'))
    setTitlesRadiologyViewer(t('titles.radiologyViewer'))
    setSubtitlesGroup(t('subtitles.group'))
    setLabelsUseTerms(t('labels.useTerms'))
    setLabelsPolitics(t('labels.politics'))
    setLabelsCookies(t('labels.cookies'))
    setLabelsRequests(t('labels.requests'))
    setLabelsContactWhats(t('labels.contactWhats'))
  }, [t])

  useEffect(() => {
    setWhatsAppLink(`https://wa.me/${labelsContactWhats.replace(/\D/g, '')}`)
  }, [labelsContactWhats])

  useEffect(() => {
    if (!windowSize.width) return

    const isDesktopSized = windowSize.width >= 1050
    if (isDesktopSized) {
      // Timeout para dar tempo do primeiro render, senão pega posição errada
      setTimeout(setNavPosition, 200)
    }
  }, [windowSize])

  useEffect(() => {
    if (didInit.current || typeof window === 'undefined') return

    didInit.current = true
    initObserver()

    const defaultLanguage = getDefaultLanguage()
    changeClientLanguage(defaultLanguage)
    setSelectedFlag(getCountryId(defaultLanguage))

    const listener = document.addEventListener(
      EVENT_KEYS.languageChange,
      () => {
        const lang = localStorage.getItem(LOCAL_KEYS.client_language)
        setSelectedFlag(getCountryId(lang))
      }
    )

    return () => {
      document.removeEventListener(EVENT_KEYS.languageChange, listener)
    }
  }, [])

  const initObserver = () => {
    const observer = new window.MutationObserver(() => {
      setNavPosition()
    })
    const div = document.getElementById('contents-menu')
    observer.observe(div, {
      attributes: true,
      childList: true,
      subtree: true,
      characterData: true
    })
  }

  const setNavPosition = () => {
    const nav = document.getElementById('button-menu')
    const div = document.getElementById('contents-menu')

    nav.style.left = `${div.offsetLeft}px`
  }

  return (
    <S.FooterContainer>
      <div className="mw-unsigned mx-auto">
        <S.NavMenu langCode={languageCode}>
          <div id="button-menu">
            <Logo color="#F8F9FD" />
            <Link href={PAGE_PATHS.contents} id="btn_footer_contents">
              {titlesContents}
            </Link>
            <Link href={PAGE_PATHS.teaching} id="btn_footer_teaching">
              {titlesTeaching}
            </Link>
            <Link href={PAGE_PATHS.resources} id="btn_footer_resources">
              {titlesResources}
            </Link>
            <Link href={PAGE_PATHS.contact} id="btn_footer_contact">
              {titlesContact}
            </Link>
            <a
              href={getLocalizedZendeskLink()}
              target="_blank"
              rel="noopener noreferrer"
              id="btn_footer_help"
            >
              {titlesHelp}
            </a>
            <S.AppContainer>
              <a
                href={EXTERNAL_PATHS.appStoreLink}
                target="_blank"
                rel="noopener noreferrer"
              >
                <ImageNext
                  src={ASSET_PATHS[`applestore_${languageCode}`]}
                  height={40}
                  width={135}
                  alt="App Store card"
                />
              </a>
              <a
                href={EXTERNAL_PATHS.playStoreLink}
                target="_blank"
                rel="noopener noreferrer"
              >
                <ImageNext
                  src={ASSET_PATHS[`playstore_${languageCode}`]}
                  height={40}
                  width={135}
                  alt="Play Store card"
                />
              </a>
            </S.AppContainer>
          </div>
        </S.NavMenu>

        <S.LinkMenu>
          <div className="desktop-only">
            <div className="flexbox v-centered h-spaced mb-4">
              <a
                href={PAGE_PATHS.facebook}
                target="_blank"
                rel="noopener noreferrer"
                id="btn_footer_facebook"
                className="social-link"
              >
                <img src={ASSET_PATHS.icon_facebook} alt="Facebook icon" />
              </a>
              <a
                href={PAGE_PATHS.instagram}
                target="_blank"
                rel="noopener noreferrer"
                id="btn_footer_instagram"
                className="social-link"
              >
                <img src={ASSET_PATHS.icon_instagram} alt="Instagram icon" />
              </a>
              <a
                href={PAGE_PATHS.youtube}
                target="_blank"
                rel="noopener noreferrer"
                id="btn_footer_youtube"
                className="social-link"
              >
                <img src={ASSET_PATHS.icon_youtube} alt="Youtube icon" />
              </a>
            </div>
            <div>
              <ReactFlagsSelect
                id="inp_flagselect_footer"
                value={selectedFlag}
                selected={selectedFlag}
                onSelect={code =>
                  changeClientLanguage(COUNTRIES[code].lang, false)
                }
                className="menu-flags"
                selectButtonClassName="menu-flags-button"
                countries={[COUNTRIES.US.id, COUNTRIES.ES.id, COUNTRIES.BR.id]}
                customLabels={{
                  US: 'English',
                  BR: 'Português',
                  ES: 'Español'
                }}
                showSelectedLabel={true}
                showOptionLabel={true}
                selectedSize={14}
              />
            </div>
          </div>

          <div id="contents-menu">
            <Link
              href={`${PAGE_PATHS.contents}?section=3&subsection=0#details`}
              className="hover"
            >
              {titlesCompleteAnatomy}
            </Link>
            <Link
              href={`${PAGE_PATHS.contents}?section=3&subsection=1#details`}
              className="hover"
            >
              {titlesTopographicAnatomy}
            </Link>
            <Link
              href={`${PAGE_PATHS.contents}?section=3&subsection=2#details`}
              className="hover"
            >
              {titlesSystemicAnatomy}
            </Link>
            <Link
              href={`${PAGE_PATHS.contents}?section=2&subsection=1#details`}
              className="hover"
            >
              {titlesCytology}
            </Link>
            <Link
              href={`${PAGE_PATHS.contents}?section=1&subsection=0#details`}
              className="hover"
            >
              {titlesEmbryology}
            </Link>
            <Link
              href={`${PAGE_PATHS.contents}?section=1&subsection=1#details`}
              className="hover"
            >
              {titlesPhysiology}
            </Link>
            <Link
              href={`${PAGE_PATHS.contents}?section=2&subsection=0#details`}
              className="hover"
            >
              {titlesHistology}
            </Link>
            <Link
              href={`${PAGE_PATHS.contents}?section=2&subsection=0#details`}
              className="hover"
            >
              {titlesHistopathology}
            </Link>
            <Link
              href={`${PAGE_PATHS.contents}?section=0&subsection=0#details`}
              className="hover"
            >
              {titlesPathology}
            </Link>
            <Link
              href={`${PAGE_PATHS.contents}?section=0&subsection=2#details`}
              className="hover"
            >
              {titlesRadiology}
            </Link>
          </div>

          <div>
            <Link href={PAGE_PATHS.teaching} className="hover">
              {titlesForTeachers}
            </Link>
            <Link href={PAGE_PATHS.contents} className="hover">
              {titlesForStudents}
            </Link>
          </div>

          <div>
            <Link
              href={`${PAGE_PATHS.contents}?section=collections`}
              className="hover"
            >
              {titlesCollections}
            </Link>
            <Link href={PAGE_PATHS.resources} className="hover">
              {titlesApp}
            </Link>
            <Link href={PAGE_PATHS.integration} className="hover">
              {titlesIntegration}
            </Link>
            <Link
              href={`${process.env.CDN_URL}/public/bioatlas/viewer`}
              className="hover"
              target="_blank"
            >
              {titlesViewer3D}
            </Link>
            <Link href="#" className="hover">
              {titlesSlideViewer}
            </Link>
            <Link href="#" className="hover">
              {titlesRadiologyViewer}
            </Link>
          </div>

          <S.ContactsMenu className="desktop-only">
            <p>{titlesContact}</p>
            <a
              href={whatsAppLink}
              target="_blank"
              rel="noopener noreferrer"
              className="hover"
              id="btn_footer_whatsapp"
            >
              <img src={ASSET_PATHS.icon_whatsapp} alt="WhatsApp icon" />
              <span>{labelsContactWhats}</span>
            </a>
            <EmailButton id="footer" iconOutline={true} />
            <a
              href={getLocalizedZendeskLink()}
              target="_blank"
              rel="noopener noreferrer"
              className="hover"
              id="btn_footer_help2"
            >
              <span className="material-icons-round">support_agent</span>
              <span>{titlesHelp}</span>
            </a>
          </S.ContactsMenu>

          <div className="desktop-only">
            <p>{titlesCompliance}</p>
            <a
              href={getItemByLang(
                PAGE_PATHS.terms_en,
                PAGE_PATHS.terms_pt,
                PAGE_PATHS.terms_es
              )}
              target="_blank"
              rel="noopener noreferrer"
              id="btn_footer_useterms"
              className="hover"
            >
              {labelsUseTerms}
            </a>
            <a
              href={getItemByLang(
                PAGE_PATHS.privacy_en,
                PAGE_PATHS.privacy_pt,
                PAGE_PATHS.privacy_es
              )}
              target="_blank"
              rel="noopener noreferrer"
              id="btn_footer_privacy"
              className="hover"
            >
              {labelsPolitics}
            </a>
            <a
              href={PAGE_PATHS.cookies}
              target="_blank"
              rel="noopener noreferrer"
              id="btn_footer_cookies"
              className="hover"
            >
              {labelsCookies}
            </a>
            <a
              href={getItemByLang(
                PAGE_PATHS.requests_en,
                PAGE_PATHS.requests_pt,
                PAGE_PATHS.requests_es
              )}
              target="_blank"
              rel="noopener noreferrer"
              id="btn_footer_requests"
              className="hover"
            >
              {labelsRequests}
            </a>
          </div>

          <div className="joined-col">
            <S.ContactsMenu>
              <p>{titlesContact}</p>
              <a
                href={whatsAppLink}
                target="_blank"
                rel="noopener noreferrer"
                id="btn_footer_whatsapp"
              >
                <img src={ASSET_PATHS.icon_whatsapp} alt="WhatsApp icon" />
                <span>{labelsContactWhats}</span>
              </a>
              <EmailButton id="footer" iconOutline={true} />
              <a
                href={getLocalizedZendeskLink()}
                target="_blank"
                rel="noopener noreferrer"
                className="hover"
                id="btn_footer_help2"
              >
                <span className="material-icons-round">support_agent</span>
                <span>{titlesHelp}</span>
              </a>
            </S.ContactsMenu>

            <div>
              <p>{titlesCompliance}</p>
              <a
                href={getItemByLang(
                  PAGE_PATHS.terms_en,
                  PAGE_PATHS.terms_pt,
                  PAGE_PATHS.terms_es
                )}
                target="_blank"
                rel="noopener noreferrer"
                id="btn_footer_useterms"
              >
                {labelsUseTerms}
              </a>
              <a
                href={getItemByLang(
                  PAGE_PATHS.privacy_en,
                  PAGE_PATHS.privacy_pt,
                  PAGE_PATHS.privacy_es
                )}
                target="_blank"
                rel="noopener noreferrer"
                id="btn_footer_privacy"
              >
                {labelsPolitics}
              </a>
              <a
                href={PAGE_PATHS.cookies}
                target="_blank"
                rel="noopener noreferrer"
                id="btn_footer_cookies"
              >
                {labelsCookies}
              </a>
              <a
                href={getItemByLang(
                  PAGE_PATHS.requests_en,
                  PAGE_PATHS.requests_pt,
                  PAGE_PATHS.requests_es
                )}
                target="_blank"
                rel="noopener noreferrer"
                id="btn_footer_requests"
              >
                {labelsRequests}
              </a>
            </div>
          </div>
        </S.LinkMenu>

        <S.MobileSocialLinks>
          <div>
            <ReactFlagsSelect
              id="inp_flagselect_footer"
              value={selectedFlag}
              selected={selectedFlag}
              onSelect={code =>
                changeClientLanguage(COUNTRIES[code].lang, false)
              }
              className="menu-flags"
              selectButtonClassName="menu-flags-button"
              countries={[COUNTRIES.US.id, COUNTRIES.ES.id, COUNTRIES.BR.id]}
              customLabels={{
                US: 'English',
                BR: 'Português',
                ES: 'Español'
              }}
              showSelectedLabel={true}
              showOptionLabel={true}
              selectedSize={14}
            />
          </div>

          <div className="flexbox v-centered">
            <a
              href={PAGE_PATHS.facebook}
              target="_blank"
              rel="noopener noreferrer"
              className="social-link"
              id="btn_footer_facebook"
            >
              <img src={ASSET_PATHS.icon_facebook} alt="Facebook icon" />
            </a>
            <a
              href={PAGE_PATHS.instagram}
              target="_blank"
              rel="noopener noreferrer"
              className="social-link"
              id="btn_footer_instagram"
            >
              <img src={ASSET_PATHS.icon_instagram} alt="Instagram icon" />
            </a>
            <a
              href={PAGE_PATHS.youtube}
              target="_blank"
              rel="noopener noreferrer"
              className="social-link"
              id="btn_footer_youtube"
            >
              <img src={ASSET_PATHS.icon_youtube} alt="Youtube icon" />
            </a>
          </div>
        </S.MobileSocialLinks>

        <S.Copyright>
          <p className="desktop-only">
            <strong>{subtitlesGroup}</strong> © {new Date().getFullYear()}{' '}
            Medical Harbour
          </p>

          <div className="mobile-only">
            <p>
              <strong>{subtitlesGroup}</strong>
            </p>
            <p>© {new Date().getFullYear()} Medical Harbour</p>
          </div>
        </S.Copyright>
      </div>
    </S.FooterContainer>
  )
}

export default FooterUnsigned
